import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "cja-date-ranges"
    }}>{`CJA Date Ranges`}</h1>
    <p>{`The Date Range API allows you to retrieve a list of ranges, get a single date range, update a date range, or create a date range through Adobe Developer.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Adobe may add optional request and response members (name/value pairs) to existing API objects at any time and without notice or changes in versioning. Adobe recommends that you refer to the API documentation of any third-party tool you integrate with our APIs so that such additions are ignored in processing if not understood. If implemented properly, such additions are non-breaking changes for your implementation. Adobe will not remove parameters or add required parameters without first providing standard notification through release notes.`}</p>
    <h2 {...{
      "id": "get-date-ranges"
    }}>{`Get Date Ranges`}</h2>
    <p>{`The following `}<inlineCode parentName="p">{`GET`}</inlineCode>{` returns dateranges the user has access to.`}</p>
    <p><inlineCode parentName="p">{`GET https://cja.adobe.io/dateranges`}</inlineCode></p>
    <p>{`Additional details may be requested by using the query parameters below.`}</p>
    <h3 {...{
      "id": "query-string-parameters"
    }}>{`Query String Parameters`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Query String`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Possible Values`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`filterByIds`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Comma separated list of date range ids. Returns only date ranges with these ids`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`id1,id2`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`expansion`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Allows requests for some response fields to be populated that would otherwise not be included.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ownerFullName,modified,definition,tags,shares`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`includeType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Alters the set of date ranges that are included in API responses.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`all,shared,templates`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`limit`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of results per page. If left `}<inlineCode parentName="td">{`null`}</inlineCode>{`, the default size is 100.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`10`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`page`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Page number. The first page is indexed at 0.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "example--get-date-ranges"
    }}>{`Example : Get date ranges`}</h3>
    <p>{`Request:`}</p>
    <p><inlineCode parentName="p">{`GET https://cja.adobe.io/dateranges`}</inlineCode></p>
    <p>{`Response:`}</p>
    <pre><code parentName="pre" {...{}}>{`{
  "content": [
    {
      "id": "5a5e294452faff002119a986",
      "name": "Curated Data Range Test",
      "description": "Curated Data Range Test",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "591f2edabef0d37113bbcbf5",
      "name": "Sample Date Range (Don't delete it)",
      "description": "Sample Date Range",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e79255b4201ce1b3cfd7b2b",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e793112e58055470d34589a",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e7a1334e58055470d34592f",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e8b80ca1d77104488659d9a",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e8b80d7c50fbf606ac3843b",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e8b80df7f17335cfa66680a",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e8b80e90d087502cdf43b67",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    },
    {
      "id": "5e8b80f18191bc0e83c22b1a",
      "name": "Integration Test 1",
      "description": "Integration Test 1 Description",
      "owner": {
        "id": 622291
      },
      "createDate": null,
      "disabledDate": null
    }
  ],
  "totalElements": 34,
  "totalPages": 4,
  "numberOfElements": 10,
  "number": 0,
  "firstPage": true,
  "lastPage": false,
  "sort": null,
  "size": 10
}
`}</code></pre>
    <h2 {...{
      "id": "retrieving-a-single-date-range"
    }}>{`Retrieving a single Date Range`}</h2>
    <p>{`To retrieve a single date range, include its `}<inlineCode parentName="p">{`id`}</inlineCode>{` in the request.`}</p>
    <h3 {...{
      "id": "example-request"
    }}>{`Example request`}</h3>
    <p><inlineCode parentName="p">{`GET https://cja.adobe.io/dateranges/5a5e294452faff002119a986`}</inlineCode></p>
    <h3 {...{
      "id": "example-response"
    }}>{`Example response`}</h3>
    <pre><code parentName="pre" {...{}}>{`{
  "id": "5a5e294452faff002119a986",
  "name": "Curated Data Range Test",
  "description": "Curated Data Range Test",
  "owner": {
    "id": 622291
  },
  "definition": "tm/tm+1m",
  "createDate": null,
  "disabledDate": null
}
`}</code></pre>
    <h2 {...{
      "id": "deleting-a-date-range"
    }}>{`Deleting a Date Range`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`DELETE`}</inlineCode>{` single date range can be used to remove a date range that is no longer needed.`}</p>
    <h3 {...{
      "id": "example-delete-request"
    }}>{`Example `}<inlineCode parentName="h3">{`DELETE`}</inlineCode>{` request`}</h3>
    <p>{`The request is the same as retrieving a single date range except to change the HTTP method to `}<inlineCode parentName="p">{`DELETE`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`DELETE https://cja.adobe.io/dateranges/5a5e294452faff002119a986`}</inlineCode></p>
    <h2 {...{
      "id": "updating-or-changing-a-date-range"
    }}>{`Updating or Changing a Date Range`}</h2>
    <p>{`Existing date ranges can be edited via the `}<inlineCode parentName="p">{`PUT`}</inlineCode>{` /dateranges/`}{`[date range id]`}{` endpoint. Most date range fields can be updated, not including those that are derived or provided by the API.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`PUT`}</inlineCode>{` endpoint also supports partial updates. This means that instead of sending the entire JSON object to the API, the request may include only the fields that need to be updated.`}</p>
    <h3 {...{
      "id": "example-put-request"
    }}>{`Example `}<inlineCode parentName="h3">{`PUT`}</inlineCode>{` request`}</h3>
    <p>{`The following example shows JSON fields to be updated with a `}<inlineCode parentName="p">{`PUT`}</inlineCode>{` request:`}</p>
    <p><inlineCode parentName="p">{`PUT https://cja.adobe.io/dateranges/5a5e294452faff002119a986`}</inlineCode></p>
    <p>{`with payload`}</p>
    <pre><code parentName="pre" {...{}}>{`{
    "name": "new name",
    "description": "new description",
    "definition": "tm/tm+1m"
}
`}</code></pre>
    <h2 {...{
      "id": "creating-a-date-range"
    }}>{`Creating a Date Range`}</h2>
    <p>{`Date Range names are allowed to include utf-8 character combinations that are not empty strings or null. However, if the name is too long, it does not display properly in the UI, so provide only useful and understandable names to improve readability.`}</p>
    <p>{`To create a date range with the CJA APIs:`}</p>
    <ol>
      <li parentName="ol">{`Define/Specify/Configure/Build a definition.`}</li>
      <li parentName="ol">{`Specify a name. The name should be descriptive of what the date range does. The description field can provide additional context about the date range.`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`POST`}</inlineCode>{` to the `}<inlineCode parentName="li">{`/dateranges`}</inlineCode>{` endpoint.`}</li>
    </ol>
    <h2 {...{
      "id": "api-status-codes"
    }}>{`API status codes`}</h2>
    <p>{`For a description of API status codes and tips for troubleshooting, see the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/landing/troubleshooting.html#api-status-codes"
      }}>{`Platform FAQ and troubleshooting guide`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      